import { render, staticRenderFns } from "./AntStar.vue?vue&type=template&id=29316f21&scoped=true"
import script from "./AntStar.vue?vue&type=script&lang=js"
export * from "./AntStar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29316f21",
  null
  
)

export default component.exports